export default __webpack_public_path__ + "static/case-6-ffd90c943baa9eecfff64ba88efdaf56.webp";